import React from 'react';
import PropTypes from 'prop-types';
import grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import PlaneIcon from '../../../../../icons/PlaneIcon';
import TrashIcon from '../../../../../icons/TrashIcon';
import ShareAction from '../../../../../enums/ShareAction';

const useStyles = makeStyles((theme) => ({
  paper: {
    maxHeight: 200,
    width: 200,
  },
  list: {
    padding: '10px 0',
  },
  listItem: {
    padding: '10px 25px',
    fontSize: 16,
    color: grey[500],
  },
  listItemIcon: {
    minWidth: 32,
    marginBottom: 3,
    color: grey[500],
  },
  planeIcon: {
    fontSize: 18,
    marginLeft: 2,
  },
  trashIcon: {
    fontSize: 20,
  },
}));

function ShareReportTableMenu({ tableType, rowMenu, onCloseMenu, onClickMenuItem }) {
  const classes = useStyles();
  const menuOpen = Boolean(rowMenu.anchorEl);
  const options = [
    {
      display: ShareAction.RESEND,
      icon: <PlaneIcon className={classes.planeIcon} />,
      iconClass: classes.listItemIcon,
    },
  ];

  if (tableType === 'shared') {
    options.unshift(
      { 
        display: ShareAction.REMOVE,
        icon: <TrashIcon className={classes.trashIcon} />,
        iconClass: classes.listItemIcon,
      }
    )
  }

  return (
    <Menu
      id="long-rowMenu"
      anchorEl={rowMenu.anchorEl}
      keepMounted
      open={menuOpen}
      onClose={onCloseMenu}
      classes={{ paper: classes.paper, list: classes.list }}
    >
      {options.map((option, index) => (
        <MenuItem key={index} onClick={e => onClickMenuItem(e, option)} classes={{ root: classes.listItem }}>
          {option.icon && <ListItemIcon className={option.iconClass}>{option.icon}</ListItemIcon>}
          {option.display}
        </MenuItem>
      ))}
    </Menu>
  );
}

ShareReportTableMenu.propTypes = {
  tableType: PropTypes.string.isRequired,
  rowMenu: PropTypes.object.isRequired,
  onCloseMenu: PropTypes.func.isRequired,
  onClickMenuItem: PropTypes.func.isRequired,
}

export default ShareReportTableMenu;


// WEBPACK FOOTER //
// ./src/components/SRHHeaders/SummaryReportHeader/components/ShareReport/components/ShareReportTableMenu.jsx